import React, { useEffect, useState } from "react";
import "./Sauces.css";
import {
  FormControl,
  FormControlLabel,
  FormLabel,
  Radio,
  RadioGroup,
} from "@mui/material";

function Sauces(props) {
  const [amount, setAmount] = useState(0);
  const [selectedItem, setSelectedItem] = useState({ name: "", amount: 0 });
  const [id, setId] = useState(props.id);
  //sauces quantity start

  const [sacesQunatity, setsacesQunatity] = useState(0);
  const {
    setOptionQuantities,
    optionQuantities,
    setSelectedOptions,
    setCheckboxOptions,
  } = props;
  const { setSauceAdded } = props;
  const [optionText, setOptionText] = useState("");
  const [optionsIds, setOptionsIds] = useState([]);

  // const props.optionButtonId = 4

  // const changeQuantity = (types, optionId, isRadio, initial = false) => {
  //   var prices = props.price;
  //   var quantity = sacesQunatity;

  //   if (types == 'plus') {
  //     console.log("call the plus")
  //     if (initial) {
  //       setsacesQunatity(sacesQunatity + (props.sauceIsCountable ? props.option.minQuantity : 1));
  //     } else {
  //       setsacesQunatity(prev => Math.min(props.option.maxQuantity, prev + (props.sauceIsCountable ? props.option.incrementalQuantity : 1)));
  //     }
  //     setOptionsIds((prev) => [prev, optionId]);
  //     setOptionQuantities((prevQuantities) => {
  //       const currentQuantity = prevQuantities[optionId] || 0; // Get current quantity for the option, default to 0
  //       let newQuantity = currentQuantity;

  //       if (types === 'plus') {
  //         // newQuantity = currentQuantity + 1;
  //         newQuantity = Math.min(
  //           props.option.maxQuantity,
  //           currentQuantity + (props.sauceIsCountable ? props.option.incrementalQuantity : 1)
  //         );
  //       } else if (types === 'minus' && currentQuantity > 0) {
  //         // newQuantity = currentQuantity - 1;
  //         newQuantity = Math.max(
  //           props.option.minQuantity,
  //           currentQuantity - (props.sauceIsCountable ? props.option.incrementalQuantity : 1)
  //         );
  //       }

  //       return {
  //         ...prevQuantities,
  //         [optionId]: newQuantity, // Update the quantity for this specific option
  //       };
  //     });

  //     quantity = quantity + 1;
  //     prices = /*(sacesQunatity + 1) */ prices;
  //   } else if (types == 'minus') {
  //     console.log("call the minus")
  //     var updatedQuantity = sacesQunatity - 1;
  //     if (updatedQuantity < 1) {
  //       console.log("call the minus if")
  //       setsacesQunatity(0);
  //       setOptionsIds((prevOptionsIds) =>
  //         prevOptionsIds.filter((x) => x !== optionId)
  //       );
  //       quantity = 0;
  //       setOptionQuantities((prevQuantities) => {
  //         const currentQuantity = 0; // Get current quantity for the option, default to 0
  //         let newQuantity = currentQuantity;

  //         return {
  //           ...prevQuantities,
  //           [optionId]: newQuantity, // Update the quantity for this specific option
  //         };
  //       });
  //     } else {
  //       console.log("call the minus else")
  //       if (props.sauceIsCountable) {
  //         setsacesQunatity(prev => Math.max(props.option.minQuantity, prev - props.option.incrementalQuantity));
  //       } else {
  //         setsacesQunatity(sacesQunatity - 1);
  //       }
  //       prices = (sacesQunatity - 1) * prices;
  //       quantity = quantity - 1;
  //       setOptionQuantities((prevQuantities) => {
  //         const currentQuantity = prevQuantities[optionId] || 0; // Get current quantity for the option, default to 0
  //         let newQuantity = currentQuantity;

  //         if (types === 'plus') {
  //           // newQuantity = currentQuantity + 1;
  //           newQuantity = Math.min(
  //             props.option.maxQuantity,
  //             currentQuantity + (props.sauceIsCountable ? props.option.incrementalQuantity : 1)
  //           );
  //         } else if (types === 'minus' && currentQuantity > 0) {
  //           // newQuantity = currentQuantity - 1;
  //           newQuantity = Math.max(
  //             props.option.minQuantity,
  //             currentQuantity - (props.sauceIsCountable ? props.option.incrementalQuantity : 1)
  //           );
  //         }

  //         return {
  //           ...prevQuantities,
  //           [optionId]: newQuantity, // Update the quantity for this specific option
  //         };
  //       });
  //     }
  //   }
  //   props.saucesCallback(id, prices, quantity, props.addonId, isRadio);
  // };

  const changeQuantity = (type, optionId, isRadio, initial = false) => {
    const increment = props.sauceIsCountable
      ? props.option.incrementalQuantity
      : 1;
    const min = props.option.minQuantity;
    const max = props.option.maxQuantity;

    setOptionQuantities((prev) => {
      const current = prev[optionId];
      let nextQty = current;

      if (type === "plus") {
        if (current === undefined) {
          nextQty = min || 1; // Start at minQuantity or 1
        } else {
          nextQty = Math.min(max, current + increment);
        }
      } else if (type === "minus") {
        nextQty = Math.max(0, (current || 0) - increment);
      }

      if (nextQty < min) {
        if (isRadio) {
          setSelectedOptions((prev) => {
            const updated = { ...prev };
            if (updated[props.addonId] === optionId) {
              delete updated[props.addonId];
            }
            return updated;
          });
        } else {
          setCheckboxOptions((prev) => {
            const current = prev[props.addonId] || [];
            return {
              ...prev,
              [props.addonId]: current.filter((id) => id !== optionId),
            };
          });
        }

        setSubOptionEnable("none");
        props.setsubOptions((prevSubOptions) =>
          prevSubOptions.filter((s) => s.optionId !== optionId)
        );
        props.handleSubOptionChange(optionId, "", true);
        setSelectedSubOptions((prev) => {
          const updated = { ...prev };
          delete updated[optionId];
          return updated;
        });

        setOptionsIds((prev) => prev.filter((x) => x !== optionId));
        props.saucesCallback(optionId, 0, 0, props.addonId, isRadio, true);

        const { [optionId]: _, ...rest } = prev;
        return rest;
      }

      if (type === "plus") {
        if (isRadio) {
          props.setSelectedOptions((prev) => ({
            ...prev,
            [props.addonId]: optionId,
          }));
          setOptionsIds([optionId]);
        } else {
          setCheckboxOptions((prev) => {
            const current = prev[props.addonId] || [];
            if (!current.includes(optionId)) {
              return {
                ...prev,
                [props.addonId]: [...current, optionId],
              };
            }
            return prev;
          });
          setOptionsIds((prev) => [...prev, optionId]);
        }

        props.saucesCallback(
          optionId,
          props.price,
          nextQty,
          props.addonId,
          isRadio
        );
      }

      return {
        ...prev,
        [optionId]: nextQty,
      };
    });
  };

  // const changeQuantity = (types, optionId) => {
  //   let newQuantity = 0
  //   setOptionQuantities((prevQuantities) => {
  //     const currentQuantity = prevQuantities[optionId] || 1; // Get current quantity for the option, default to 0
  //     newQuantity = currentQuantity;

  //     if (types === "plus") {
  //       newQuantity = currentQuantity + 1;
  //     } else if (types === "minus" && currentQuantity > 0) {
  //       newQuantity = currentQuantity - 1;
  //     }

  //     return {
  //       ...prevQuantities,
  //       [optionId]: newQuantity, // Update the quantity for this specific option
  //     };
  //   });

  //   // Trigger the callback with updated values (if needed)
  //   const prices = newQuantity * props.price;
  //   props.saucesCallback(optionId, prices, newQuantity, props.addonId);
  // };
  //sauces quantity end
  useEffect(() => {
    if (sacesQunatity > 0) {
      setSauceAdded(true);
    } else if (sacesQunatity === 0) {
      setSauceAdded(false);
    }

    setAmount(sacesQunatity * props.price);
    setSelectedItem({ name: props.name, amount: amount });
  }, [sacesQunatity]);
  // useEffect(() => {
  //   setSelectedItem({ name: props.name, amount: amount });
  //   props.saucesCallback(id, amount, sacesQunatity);
  // }, [amount]);
  // props.subOptions.map((subop) =>
  //   console.log("added sub option", props.subOptions.includes(subop.id))
  // );

  const [subOptionEnable, setSubOptionEnable] = useState("none");
  const [selectedSubOptions, setSelectedSubOptions] = useState({});
  // const subOptionOnclick = (subOption) => {
  //   // alert(subOption);
  //   if (
  //     selectedSubOptions ||
  //     (selectedSubOptions?.subOptionId != subOption.subOptionId &&
  //       selectedSubOptions?.optionId == subOption.optionId)
  //   ) {
  //     alert("if");
  //     setSubOptionEnable(subOption.optionId + subOption.subOptionId);

  //     props.setsubOptions((prevState) => [...prevState, subOption]);

  //     setSelectedSubOptions(subOption);

  //     props.subOptionCallBack(subOption);

  //     props.handleSubOptionChange(props.id, subOption.subOptionId);
  //   } else {
  //     alert("else");
  //     setSubOptionEnable("none");
  //     props.setsubOptions((prevSubOptions) => {
  //       const subOptionExists = prevSubOptions.some(
  //         (x) =>
  //           x.optionId === subOption.optionId &&
  //           x.subOptionId === subOption.subOptionId
  //       );

  //       if (subOptionExists) {
  //         return prevSubOptions.filter(
  //           (x) =>
  //             !(
  //               x.optionId === subOption.optionId &&
  //               x.subOptionId === subOption.subOptionId
  //             )
  //         );
  //       } else {
  //         return [...prevSubOptions, [...prevSubOptions, subOption]];
  //       }
  //     });
  //     props.subOptionCallBack(subOption);
  //     props.handleSubOptionChange(props.id, subOption.subOptionId);

  //     setSelectedSubOptions({});
  //   }
  // };

  const subOptionOnclick = (subOption) => {
    if (!props.selectedOptions[props.addonId]) {
      // Parent is not selected; ignore suboption clicks
      return;
    }

    // Check if selectedSubOptions is not null and if its optionId and subOptionId match the current subOption
    var combinedId = subOption.optionId + subOption.subOptionId;
    if (combinedId != subOptionEnable) {
      // This is the "if" block
      setSubOptionEnable(subOption.optionId + subOption.subOptionId);

      props.setsubOptions((prevState) => [...prevState, subOption]);

      setSelectedSubOptions(subOption);

      props.subOptionCallBack(subOption);

      props.handleSubOptionChange(props.id, subOption.subOptionId);
    } else {
      setSubOptionEnable("none");
      props.setsubOptions((prevSubOptions) => {
        const subOptionExists = prevSubOptions.some(
          (x) =>
            x.optionId === subOption.optionId &&
            x.subOptionId === subOption.subOptionId
        );

        if (subOptionExists) {
          // Remove the existing subOption
          return prevSubOptions.filter(
            (x) =>
              !(
                x.optionId === subOption.optionId &&
                x.subOptionId === subOption.subOptionId
              )
          );
        } else {
          // Add the new subOption
          return [...prevSubOptions, subOption];
        }
      });
      props.subOptionCallBack(subOption);
      props.handleSubOptionChange(props.id, subOption.subOptionId);

      setSelectedSubOptions({});
    }
  };

  const [optionEnable, setOptionEnable] = useState(false);

  // const optionOnclick = (optionId) => {
  //   if (!optionEnable) {
  //     console.log("calling if")
  //     setOptionEnable(true);
  //     props.handleRadioButtonChange(props.addonId, props.id); // Add the option to parent state
  //     changeQuantity('plus', props.id, true, true); // Increment quantity
  //     props.setsubOptions([]);
  //     props.handleSubOptionChange(props.id, "", true);
  //   } else {
  //     console.log("calling else")
  //     setOptionEnable(false);
  //     setsacesQunatity(0)
  //     setOptionQuantities((prev) => {
  //       const { [optionId]: _, ...rest } = prev;
  //       return rest;
  //     });
  //     props.handleRadioButtonChange(props.addonId, props.id); // Remove the option from parent state
  //     setSubOptionEnable(false); // Disable sub-option if any
  //     // changeQuantity('minus', props.id, true); // Decrement quantity
  //     props.saucesCallback(props.id, props.price, 0, props.addonId, true, true);
  //     props.setsubOptions([]);
  //     props.handleSubOptionChange(props.id, "", true);
  //   }
  // };

  const optionOnclick = (optionId) => {
    const isSelected = props.selectedOptions[props.addonId] === optionId;

    if (isSelected) {
      // Deselect and clear quantity
      props.setSelectedOptions((prev) => {
        const updated = { ...prev };
        delete updated[props.addonId];
        return updated;
      });

      setsacesQunatity(0);
      setOptionQuantities((prev) => {
        const { [optionId]: _, ...rest } = prev;
        return rest;
      });

      // 💥 Reset all related suboption state
      setSubOptionEnable("none"); // <--- IMPORTANT
      props.setsubOptions((prevSubOptions) =>
        prevSubOptions.filter((s) => s.optionId !== optionId)
      );
      props.handleSubOptionChange(optionId, "", true);
      setSelectedSubOptions((prev) => {
        const updated = { ...prev };
        delete updated[optionId];
        return updated;
      });

      props.saucesCallback(optionId, 0, 0, props.addonId, true, true);
      // props.setsubOptions([]);
      // props.handleSubOptionChange(optionId, "", true);
    } else {
      // Select new option
      props.setSelectedOptions((prev) => ({
        ...prev,
        [props.addonId]: optionId,
      }));
      changeQuantity("plus", optionId, true, true);
      props.setsubOptions([]);
      props.handleSubOptionChange(optionId, "", true);
    }
  };

  return (
    <>
      <div className='d-flex justify-content-between align-items-center'>
        <div
          className={`d-flex flex-row align-items-center justify-content-between ${
            props.optionButtonId === 5 || props.optionButtonId === 6
              ? "w-100"
              : "w-100"
          }`}
        >
          <h6
            className={`${
              props.optionButtonId === 5 || props.optionButtonId === 6
                ? "w-100"
                : ""
            }`}
          >
            {props.optionButtonId === 3 ? (
              <>
                <input
                  // checked={optionEnable}
                  checked={props.selectedOptions[props.addonId] === props.id}
                  onClick={() => optionOnclick(props.id)}
                  type='radio'
                  className='me-1'
                  name={`radio-${props.addonId}`}
                  // disabled={props.lessOptions && !props.isCountable}
                  // disabled={!props.checkedItems[props.addonId]}
                />
              </>
            ) : props.optionButtonId === 4 ? (
              <>
                <input
                  type='checkbox'
                  className='me-1 checkbox-gray'
                  name='options'
                  checked={(
                    props.checkboxOptions[props.addonId] || []
                  ).includes(props.id)}
                  onChange={(e) => {
                    props.handleCheckboxChange(
                      props.addonId,
                      props.id,
                      e.target.checked
                    );
                    changeQuantity(
                      optionsIds.find((x) => x == props.id) ? "minus" : "plus",
                      props.id,
                      false
                    );
                    setSubOptionEnable("None");
                  }}
                />
              </>
            ) : (
              ""
            )}

            {props.optionButtonId === 5 ? (
              <button
                className='option-btn'
                onClick={() =>
                  props.handleButtonChange(props.addonId, props.id)
                }
              >
                {props.name}
              </button>
            ) : props.optionButtonId === 6 ? (
              <textarea cols={12} rows={4} className='w-100 option-details'>
                {props.name}
              </textarea>
            ) : (
              <>
                <span>
                  {props.name}
                  {props.sauceIsMandatory && (
                    <span className='text-danger'>*</span>
                  )}
                  {props.sauceIsCountableLinked &&
                    ` x${props.foodItemQuantity}`}
                </span>
                {props.subOptionWarnings && (
                  <div className='warning-text text-warning'>
                    {props.subOptionWarnings}
                  </div>
                )}
              </>
            )}
          </h6>
          <div
            className={`${
              props.optionButtonId === 5 || props.optionButtonId === 6
                ? "d-none"
                : "d-flex"
            }`}
          >
            {amount == 0 ? (
              <p style={{ margin: "0px 5px" }}>£{props.price}</p>
            ) : (
              <p style={{ margin: "0px 5px" }}>
                £
                {props.sauceIsCountableLinked
                  ? props.price * props.foodItemQuantity
                  : props.isCountable
                  ? props.price * props.notLinkedAddonQuantity
                  : amount}
              </p>
            )}
            {/* {props.sauceIsCountableLinked && props.linkedOptionTotal > 0 ? <p>£ {props.linkedOptionTotal}</p> : <p>£ {props.price}</p>} */}
          </div>
        </div>

        {/* Options Quantity */}
        {/* {props.sauceIsCountable && !props.sauceIsCountableLinked && (
          <div
            className={`${!props.sauceIsCountable ||
              props.optionButtonId === 5 ||
              props.optionButtonId === 6
              ? 'd-none'
              : 'd-flex'
              }`}
            style={{ gap: '10px', }}
          >
            {sacesQunatity > 0 && (
              <>
                <div
                  onClick={() => {
                    changeQuantity('minus', props.id, props.optionButtonId === 3 ? true : false);
                  }}
                  className={`plusCircle ${props.isCountableLinked && "not-clickable"}`}
                >
                  <p>-</p>
                </div>
                <div style={{ marginTop: '5px' }}>{
                  props.isCountableLinked
                    ?
                    props.foodItemQuantity
                    :
                    sacesQunatity
                }
                </div>
              </>
            )}
            <div
              onClick={() => {
                changeQuantity('plus', props.id, props.optionButtonId === 3 ? true : false);
              }}
              className={`plusCircle ${props.isCountableLinked && "not-clickable"}`}
            >
              <p>+</p>
            </div>
          </div>
        )} */}

        {props.sauceIsCountable && !props.sauceIsCountableLinked && (
          <div
            className={`${
              !props.sauceIsCountable ||
              props.optionButtonId === 5 ||
              props.optionButtonId === 6
                ? "d-none"
                : "d-flex"
            }`}
            style={{ gap: "10px" }}
          >
            {optionQuantities[props.id] > 0 && (
              <>
                <div
                  onClick={() => {
                    changeQuantity(
                      "minus",
                      props.id,
                      props.optionButtonId === 3
                    );
                  }}
                  className={`plusCircle ${
                    props.isCountableLinked && "not-clickable"
                  }`}
                >
                  <p>-</p>
                </div>
                <div style={{ marginTop: "5px" }}>
                  {props.isCountableLinked
                    ? props.foodItemQuantity
                    : optionQuantities[props.id]}
                </div>
              </>
            )}

            <div
              onClick={() => {
                changeQuantity("plus", props.id, props.optionButtonId === 3);
              }}
              className={`plusCircle ${
                props.isCountableLinked && "not-clickable"
              }`}
            >
              <p>+</p>
            </div>
          </div>
        )}

        {/* {!props?.isCountable && props?.sauceIsCountable && (
          <div
            className={`${
              !props.isCountable ||
              props.optionButtonId === 5 ||
              props.optionButtonId === 6
                ? 'd-none'
                : 'd-flex'
            }`}
            style={{ gap: '10px' }}
          >
            {sacesQunatity > 0 && (
              <>
                <div
                  onClick={() => {
                    changeQuantity('minus', props.id);
                  }}
                  className=' plusCircle'
                >
                  <p>-</p>
                </div>

                {sacesQunatity}
              </>
            )}
            <div
              onClick={() => {
                changeQuantity('plus', props.id);
              }}
              className=' plusCircle'
            >
              <p>+</p>
            </div>
          </div>
      )} */}
      </div>
      {/* {subOptionEnable} */}
      {/* {sacesQunatity > 0 && ( */}

      {/* SubOption displaying */}
      {(props.selectedOptions[props.addonId] === props.id ||
        props.checkboxOptions[props.addonId]?.includes(props.id)) && (
        <div style={{ marginLeft: "1.5rem" }}>
          <FormControl>
            <RadioGroup
              aria-labelledby='demo-radio-buttons-group-label'
              defaultValue='female'
              name='radio-buttons-group'
              value={subOptionEnable}
            >
              {props.subOptions.map((subOption, i) => {
                const isSelected =
                  props.selectedSubOptions[props.id] === subOption.subOptionId;

                let displayPrice = 0;

                if (isSelected && props.isCountable) {
                  displayPrice = subOption.price * props.notLinkedAddonQuantity;
                } else if (isSelected && props.sauceIsCountable) {
                  displayPrice =
                    subOption.price * props.subOptionQuantityOptionCountable;
                } else {
                  displayPrice = subOption.price;
                }
                // const displayPrice = isSelected && isCountable
                // ? subOption.price * props.subOptionQuantityOptionCountable
                // : subOption.price;

                return (
                  <>
                    {/* <div className="form-check p-0 ms-4 checkBoxOrderPage">
                      <input
                        style={{ float: "left", margin: "5px 5px 0px 0px" }}
                        type="radio"
                        name={subOption.optionId + props.addonId}
                        id={
                          subOption.subOptionId +
                          subOption.optionId +
                          props.addonId
                        }
                        value={subOption.price}
                        checked={subOptionEnable}
                        onClick={() => subOptionOnclick(subOption)}
                      />

                      <div className="d-flex justify-content-between">
                        <label
                          className="form-check-label "
                          for={subOption.optionId + props.addonId}
                        >
                          {subOption.subOptionName}
                        </label>
                        <p>£ {subOption.price}</p>
                      </div>
                    </div> */}
                    <FormControlLabel
                      value={subOption.optionId + subOption.subOptionId}
                      control={<Radio />}
                      label={`${subOption.subOptionName} £${displayPrice}`}
                      onClick={() => subOptionOnclick(subOption)}
                    />
                  </>
                );
              })}
            </RadioGroup>
          </FormControl>
        </div>
      )}
    </>
  );
}

export default Sauces;
